import { getPaperListData } from '@/infrastructure/api-functions';
import { ListBaseService } from '@eureka/shared/solution-card';
import type { ISolutionListResponse } from '@eureka/shared/solution-card/src/types';

export class PaperListService extends ListBaseService {
    protected fetchData(data: {
    page: number;
    limit: number;
    data?: Record<string, unknown>;
  }): Promise<ISolutionListResponse> {
        return getPaperListData(data).then((res) => {
            res.records = res.records.map((item) => {
                return {
                    ...item,
                    ORG_INFO: item.ORG_INFO?.map(
                        (org) => {
                            return {
                                display_name: org.normalized_display_name,
                                id: org.normalized_id,
                                logo: org.normalized_logo,
                            };
                        }
                    ),
                };
            });
            return res;
        });
    }
}
